import ContactCitySection from './components/ContactCitySection.vue';
import InitComponent from 'Modules/InitComponent';

const section = document.getElementById('contact-city-section');
const initComponent = new InitComponent({
  selectors: section,
  components: { ContactCitySection },
  template: '<ContactCitySection />',
});

initComponent.init();
